import { types, getRoot } from 'mobx-state-tree';

const GTM_SCRIPT_ID = 'gtm-script';

const ensureDataLayer = () => {
  if (typeof window === 'undefined') return null;

  window.dataLayer = window.dataLayer || [];

  return window.dataLayer;
};

const injectGtmScript = gtmId => {
  if (typeof document === 'undefined') return false;

  const dataLayer = ensureDataLayer();

  if (!dataLayer) return false;

  const existingScript = document.getElementById(GTM_SCRIPT_ID);
  if (existingScript) return true;

  dataLayer.push({
    'gtm.start': Date.now(),
    event: 'gtm.js',
  });

  const script = document.createElement('script');
  script.id = GTM_SCRIPT_ID;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(gtmId)}`;

  document.head.appendChild(script);

  return true;
};

export const analyticsInitialState = {
  isInitialized: false,
};

export const analyticsModel = types
  .model('AnalyticsStore', {
    isInitialized: types.optional(types.boolean, false),
  })
  .actions(self => ({
    initialize(gtmId) {
      if (!gtmId || self.isInitialized) return;

      self.isInitialized = injectGtmScript(gtmId);
    },

    trackEvent(action, params = {}) {
      if (!self.isInitialized) return;

      const dataLayer = ensureDataLayer();

      if (!dataLayer) return;

      const root = getRoot(self);
      const userStore = root.userStore;

      const userProfile = userStore?.profile;

      const userRole = userProfile?.currentEstablishmentRole;

      const defaultData = {
        timestamp: new Date().toISOString(),
        user_name: userProfile?.fullName || 'unknown',
        user_id: userProfile?.id || 'guest',
        role: userRole?._role_name || 'none',
        establishment_id: userRole?._establishment_id || 'unknown',
        establishment_name: userRole?._establishment_name || 'none',
      };

      dataLayer.push({
        event: action,
        ...defaultData,
        ...params,
      });
    },
  }));
